import React from 'react'

const Footer = () => {
  return (
    <div className="footer">
      <div className="container section">
        <div className="footer-content">
          <div className="heading">
            <p className="text-size-8 text-centered">Copyright © 2020 M. Tanaka Lab All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  ) 
}

export default Footer